export default __webpack_public_path__ + "static/media/bookIcon.ac998b5d.svg";